import Pages from '../../../config/Pages';
import { permissionEnums } from '../../../core/enums/PermissionEnums';
import { Route } from '../../../core/utils/RouteMixins';
import Listagem from './historicoIndicadorListagem/HistoricoIndicadorListagem';
import Form from './historicoIndicadorForm/HistoricoIndicadorForm';

const historicoIndicadorRoutes = [
    Route(null, Pages.sei.historicoIndicador.url.list, Listagem, [
        permissionEnums.HISTORICO_INDICADOR_VISUALIZAR,
    ]),
    Route(null, Pages.sei.historicoIndicador.url.view, Form, [
        permissionEnums.HISTORICO_INDICADOR_CONSULTAR,
    ]),
];

export default historicoIndicadorRoutes;
